import { Capacitor } from "@capacitor/core";

/** Sent to ai-coach-chat for iOS-specific hints (Apple Health, etc.) */
export function getStraivClientPlatform(): "ios" | "android" | "web" {
  if (!Capacitor.isNativePlatform()) return "web";
  const p = Capacitor.getPlatform();
  if (p === "ios") return "ios";
  if (p === "android") return "android";
  return "web";
}
